import React, { Fragment, Suspense, lazy, useState, useEffect } from "react";
import { MuiThemeProvider, CssBaseline } from "@material-ui/core";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import theme from "./theme";
import GlobalStyles from "./GlobalStyles";
import * as serviceWorker from "./serviceWorker";
import Pace from "./shared/components/Pace";

import services from "./services";
const AuthService = services.authorizationEnviospetService;

const LoggedInComponent = lazy(() => import("./logged_in/components/Main"));
const LoggedOutComponent = lazy(() => import("./logged_out/components/Main"));

function App() {
  const [user, setUser] = useState(null);
  const [isLegacyUser, setIsLegacyUser] = useState(false);

  useEffect(()=>{
    const isLegacyUser = AuthService.verifyLegacyUser();
    setIsLegacyUser(isLegacyUser);
    const user = AuthService.getCurrentUser();
    if(user) setUser(user);
  }, [setUser]);
  
  return (
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        <Pace color={theme.palette.primary.light} />
        <Suspense fallback={<Fragment />}>
          <Switch>
            <Route path="/admin">
              <LoggedInComponent user={user} isLegacyUser={isLegacyUser}/>
            </Route>
            <Route>
              <LoggedOutComponent />
            </Route>
          </Switch>
        </Suspense>
      </MuiThemeProvider>
    </BrowserRouter>
  );
}
serviceWorker.register();
export default App;
